export type PinConfigEntry = {
  representation?: string;
  type?: string;
  sub_type?: string;
  unit?: string;
};

export function pinConfigMapByRepresentation(
  pinConfigurations: PinConfigEntry[]
): Map<string, PinConfigEntry> {
  const map = new Map<string, PinConfigEntry>();
  pinConfigurations.forEach((config) => {
    if (config.representation) {
      map.set(config.representation, config);
    }
  });
  return map;
}

export function isTemperatureLikeSensor(sensor: {
  type?: string;
  pin_type?: string;
  sensor_name?: string;
  representation?: string;
}): boolean {
  const pinType = sensor.pin_type || sensor.type;
  return (
    pinType === 'temperature' ||
    sensor.sensor_name === 'sc' ||
    sensor.sensor_name === 'sh'
  );
}

export function resolvePlotUnit(
  sensor: {
    representation?: string;
    type?: string;
    pin_type?: string;
    sensor_name?: string;
    unit?: string;
  },
  pinConfigByRepresentation: Map<string, PinConfigEntry>,
  assetTemperatureUnit?: 'F' | 'C'
): string {
  const representation = sensor.representation;

  if (representation === 'outsideWeatherTemperature' || isTemperatureLikeSensor(sensor)) {
    return assetTemperatureUnit || 'F';
  }

  if (representation === 'outsideWeatherHumidity') {
    return pinConfigByRepresentation.get(representation)?.unit || sensor.unit || '%';
  }

  if (representation === 'powerConsumption') {
    return pinConfigByRepresentation.get(representation)?.unit || sensor.unit || '';
  }

  if (representation) {
    const pinConfig = pinConfigByRepresentation.get(representation);
    if (pinConfig?.unit) {
      return pinConfig.unit;
    }
  }

  return sensor.unit || '';
}

export function formatLegendLabel(displayName: string, unit?: string): string {
  const trimmedUnit = (unit || '').trim();
  if (!trimmedUnit) {
    return displayName;
  }
  if (displayName.includes(`(${trimmedUnit})`)) {
    return displayName;
  }
  return `${displayName} (${trimmedUnit})`;
}

export function pinTypeAxisTitle(pinType?: string): string {
  if (!pinType) {
    return '';
  }
  return pinType;
}
